import {clsx} from 'clsx';
import React from 'react';

function getColorClassName(
  fraction: number,
  isUnlimited: boolean,
  isOverageAllowed: boolean
) {
  if (isUnlimited || fraction < 0.9) {
    return 'bg-teal-500';
  }
  if (isOverageAllowed || fraction < 1.0) {
    return 'bg-gold-550';
  }
  return 'bg-red-500';
}

type Props = {
  fraction: number;
  isUnlimited: boolean;
  isOverageAllowed?: boolean;
  size?: 'small' | 'medium';
};

export const MeterBar = ({
  fraction,
  isUnlimited,
  isOverageAllowed = false,
  size,
}: Props) => {
  const heightClassName = size === 'small' ? 'h-6' : 'h-[15px]';

  return (
    <div className={clsx('w-full rounded bg-wb-page', heightClassName)}>
      <div
        className={clsx(
          getColorClassName(fraction, isUnlimited, isOverageAllowed),
          heightClassName,
          fraction >= 1 ? 'rounded' : 'rounded-l'
        )}
        style={{
          width: `${Math.max(0, Math.min(fraction * 100, 100))}%`,
        }}
      />
    </div>
  );
};
